export default __webpack_public_path__ + "static/media/clouds-right-large-desktop.0e7e1c14.png";